import styled from "styled-components";
import { SPACING } from "../../../../../utils/constants";
import {
  LabelRow,
  TwoColumnRow,
} from "../../../../../components/FormPanel/styles";

export const DateAmountRow = styled(TwoColumnRow)`
  ${LabelRow} {
    /* Reserve room for the duplicate form's Today action in both columns. */
    min-height: ${SPACING.xl}px;
    align-items: center;
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.md}px;
`;
